export const patientProfileBaseHref = (
  patientId: string | number,
  clinicId?: string | number | null
): string => {
  const patientPath = encodeURIComponent(String(patientId));
  const numericClinicId = Number(clinicId);
  if (Number.isInteger(numericClinicId) && numericClinicId > 0) {
    return `#/patient-profile/${patientPath}/clinic/${numericClinicId}`;
  }
  return `#/patient-profile/${patientPath}`;
};
